// 3D scan: soft depth from brightness, edges pushed out as ridges.
// Sobel is sampled at vertex spacing (1 / uSegments), not pixel spacing,
// otherwise sparse vertices would just pick up pixel noise.
vec3 displace(vec3 pos, vec2 uv, inout float elevation)
{
    vec2 d = vec2(1.0 / uSegments);
    float tl = luma(sampleCam(uv + d * vec2(-1.0,  1.0)));
    float t  = luma(sampleCam(uv + d * vec2( 0.0,  1.0)));
    float tr = luma(sampleCam(uv + d * vec2( 1.0,  1.0)));
    float l  = luma(sampleCam(uv + d * vec2(-1.0,  0.0)));
    float r  = luma(sampleCam(uv + d * vec2( 1.0,  0.0)));
    float bl = luma(sampleCam(uv + d * vec2(-1.0, -1.0)));
    float b  = luma(sampleCam(uv + d * vec2( 0.0, -1.0)));
    float br = luma(sampleCam(uv + d * vec2( 1.0, -1.0)));
    float gx = -tl - 2.0 * l - bl + tr + 2.0 * r + br;
    float gy = -tl - 2.0 * t - tr + bl + 2.0 * b + br;

    // uFrequency doubles as edge gain; smoothstep drops weak edges (noise)
    float edge = smoothstep(0.1, 1.0, length(vec2(gx, gy)) * uFrequency * 0.3);
    float depth = luma(sampleCam(uv)) * 0.3;

    elevation = edge;
    pos += normal * (depth + edge) * uStrength;
    return pos;
}
